import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import details from '../../img/details.svg';
import add from '../../img/add.svg';
import sortasc from '../../img/sort-asc.svg';
import sortdesc from '../../img/sort-desc.svg';

export default class LocationsScreen extends React.Component {
    constructor(props) {
        super(props);

        var regionid = null
        var selectedRegionId = ""
        var sortField = null
        var sortOrder = null
        var pageCount = 0
    

        const args = props.args === undefined ? {} : props.args
        
        if (args.regionid) {
            regionid = args.regionid
        }

        if (args.selectedRegionId) {
            selectedRegionId= args.selectedRegionId
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {
              args: args,
              pageLimit: 25, 
              pageCount: pageCount,   
              nameCriteria: "",
              prevNameCriteria:"",
              regionid: regionid, 
              selectedRegionId: selectedRegionId,
              locations: [],
              regionOptions: [],
              sortField: sortField, 
              sortOrder: sortOrder  
        }

        this.regionChangeHandler = this.regionChangeHandler.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this); 
        this.sortClicked = this.sortClicked.bind(this);   
        this.nameSearch = this.nameSearch.bind(this);  
        
        setTimeout(this.nameSearch, 2000);
    }  
    
    async componentDidMount() {
        this.getDataWithCritera()
        
        this.getRegionOptons()
    }

    getDataWithCritera() {
        var parameters = {}

        if (this.state.regionid) {
            parameters.regionid = this.state.regionid
        }   
        else {
            parameters.regionid = this.state.selectedRegionId
        }
        
        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

    
        BaseApi.get('/locations', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({locations: res.data})
        })    
        .catch(error=>console.log(error))
    }

    getRegionOptons() {
        BaseApi.get("/regions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const regionOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            regionOptions.push({value: "", label: "Все"})
            this.setState({regionOptions: regionOptions})
        })    
        .catch()
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCritera)
        }
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "regionCaption" :
                if (currentField === "region") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "region"
                    currentOrder = "asc"
                }
            break
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break         
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCritera)
    }

    regionChangeHandler(selectedOption) {
        var args = this.state.args
        args.pageCount = 0
        this.setState({selectedRegionId: selectedOption.value, pageCount: 0, args: args}, this.getDataWithCritera)
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }

    openLocation(id) {
        this.props.navigate("location", {caller: "locations", callargs: this.state.args, location: id, region: this.state.regionid})
    }

    renderLocation(location) {
        return (
            <tr 
                id = {location.id}
                className="table-row-clickable"
                onClick={()=>this.openLocation(location.id)}
            >
                    {this.state.regionid === null && 
                        <td style={{textAlign: 'left',  padding: '4px'}}>{location.region}</td>
                    }     
                    <td style={{textAlign: 'left',  padding: '4px'}}>{location.name}</td>
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
            <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Населенные пункты"}/>

            <div className="row mt-4 mb-3">
                <div className="col-lg-6">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h6 className="card-title mb-3">Фильтр</h6>
                            <div className="mb3">
                                <label for="name">Название:</label>
                                <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                            </div>
                            {this.state.regionid === null && 
                                <div className="mb-3"> 
                                    <label for="region">Регион:</label>
                                    <Select options= {this.state.regionOptions} 
                                            id="program" 
                                            onChange={this.regionChangeHandler}
                                            />
                                </div>
                            }     
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button className="btn btn-primary d-flex align-items-center" onClick={()=>{this.openLocation("")}}>
                                Добавить населенный пункт
                            </button>
                        </div>
                    </div>
            </div>    
            <div className="card shadow-sm">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-sm table-hover mb-0 align-middle">
                            <thead className="table-primary">
                                <tr>
                                    {this.state.regionid === null && 
                                        <th
                                            id="regionCaption"
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}
                                        >
                                             Регион{" "}
                                            {this.isFieldSortedDesc("region") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("region") && <img src={sortasc} height="16" width="16"/>}
                                        
                                        </th>
                                       
                                    }
                                    <th 
                                        id="nameCaption"
                                        style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        onClick={this.sortClicked}
                                    >
                                        Наименование{" "}
                                        {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                                        {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                                            
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                 {this.state.locations.map((value, index) => this.renderLocation(value))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {/*
            <div class="row mt-5" style={{"height" : "50px"}}>
                    {this.state.regionid === null && 
                        <div class="col-3 text-left border border-white"
                            id="regionCaption"
                            style={{"background-color" : "#0ee"}}
                            onClick={this.sortClicked}>
                            Регион
                            {this.isFieldSortedDesc("region") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("region") && <img src={sortasc} height="16" width="16"/>}
                        </div>
                    } 
                    <div class="col-3 text-left border border-white"
                         id="nameCaption"
                         style={{"background-color" : "#0ee"}} 
                         onClick={this.sortClicked}>
                            Наименование
                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                         </div>
             
                    <div class="col-1 border border-white"
                         style={{"background-color" : "#0ee"}}
                         onClick={()=>{this.openLocation("")}}><img src={add} height="16" width="16"/>
                    </div>     
                </div>  
            */}      
           
        </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/locations.js